import { FaSearch } from "react-icons/fa";

export default function SearchBar({
    value,
    onChange,
    onSearch,
    onKeyDown,
    placeholder = "Buscar productos…",
    autoFocus = false,
    variant = "default"
}) {
    const baseWrapper =
        variant === "modal"
            ? "p-4 border-b bg-white sticky top-0 z-10"
            : "bg-white rounded-md shadow-sm overflow-hidden";

    const baseInput =
        "flex-1 px-4 py-2 border border-gray-300 rounded-lg text-black " +
        "focus:outline-none focus:border-brand-primary";

    const baseButton =
        variant === "modal"
            ? "px-4 bg-brand-primary text-white rounded-lg hover:brightness-90 transition flex items-center gap-2"
            : "px-4 text-brand-primary font-bold";

    return (
        <div className={baseWrapper}>
            <div className="flex bg-white rounded-md shadow-sm overflow-hidden gap-2">
                <input
                    className={baseInput}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    autoFocus={autoFocus}
                />
                <button className={baseButton} onClick={onSearch}>
                    <FaSearch />
                    {variant === "modal" && "Buscar"}
                </button>
            </div>
        </div>
    );
}
